var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page',[(_vm.filterModel)?_c('Filters',{attrs:{"slot":"left-column","model":_vm.filterModel,"color":"reseau"},slot:"left-column"}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }